import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  style: {
    "font-size": "32px",
    "font-weight": "bolder"
  }
};
var _hoisted_2 = {
  style: {
    "flex": "1",
    "position": "relative"
  }
};
var _hoisted_3 = {
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "right": "0",
    "bottom": "0"
  }
};
import { computed, reactive, ref } from 'vue';
import TableSelect from './components/table-select/TableSelect.vue';
import TableProp from './components/table-prop/TableProp.vue';
import CodeGenerator from './components/code-generator/CodeGenerator.vue';
import { ArrowRight, ArrowLeft } from '@element-plus/icons-vue';
var TAB_TABLE_SELECT = 'table-select';
var TAB_TABLE_PROP = 'table-prop';
var TAB_CODE_GEN = 'code-gen';
export default /*@__PURE__*/_defineComponent({
  __name: 'Codegen',
  setup: function setup(__props) {
    var tablePropRef = ref();
    var tableSelectRef = ref();
    var tabRef = ref();
    var tab = reactive({
      active: TAB_TABLE_SELECT,
      tableSelect: {
        tableName: ''
      },
      tableProp: {
        business: {}
      }
    });
    var title = computed(function () {
      if (isTabActive(TAB_TABLE_SELECT)) {
        return '选择表';
      } else if (isTabActive(TAB_TABLE_PROP)) {
        return '调整属性';
      } else if (isTabActive(TAB_CODE_GEN)) {
        return '生成代码';
      }
      return '';
    });
    function handleTableSelect(table) {
      gotoTableProp(table);
    }
    function nextStep() {
      if (isTabActive(TAB_TABLE_SELECT)) {
        var _tableSelectRef$value;
        gotoTableProp((_tableSelectRef$value = tableSelectRef.value) === null || _tableSelectRef$value === void 0 ? void 0 : _tableSelectRef$value.getSelectedTableName());
      } else if (isTabActive(TAB_TABLE_PROP)) {
        gotoCodeGen();
      }
    }
    function gotoTableProp(tableName) {
      if (!tableName) {
        return;
      }
      tab.tableSelect.tableName = tableName;
      switchTab(TAB_TABLE_PROP);
    }
    function gotoCodeGen() {
      var _tablePropRef$value;
      var business = (_tablePropRef$value = tablePropRef.value) === null || _tablePropRef$value === void 0 ? void 0 : _tablePropRef$value.getBusiness();
      if (!business) {
        return;
      }
      tab.tableProp.business = business;
      switchTab(TAB_CODE_GEN);
    }
    function previousStep() {
      if (isTabActive(TAB_TABLE_PROP)) {
        switchTab(TAB_TABLE_SELECT);
      } else if (isTabActive(TAB_CODE_GEN)) {
        switchTab(TAB_TABLE_PROP);
      }
    }
    function switchTab(tb) {
      tab.active = tb;
    }
    function isTabActive(tb) {
      return tab.active === tb;
    }
    return function (_ctx, _cache) {
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_icon = _resolveComponent("el-icon");
      var _component_el_button_group = _resolveComponent("el-button-group");
      var _component_el_row = _resolveComponent("el-row");
      var _component_el_divider = _resolveComponent("el-divider");
      var _component_el_tab_pane = _resolveComponent("el-tab-pane");
      var _component_el_tabs = _resolveComponent("el-tabs");
      var _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(function () {
          return [_createElementVNode("div", null, [_createVNode(_component_el_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 20
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("span", _hoisted_1, _toDisplayString(title.value), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 4
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_button_group, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_button, {
                        type: "success",
                        icon: _unref(ArrowLeft),
                        onClick: previousStep
                      }, {
                        default: _withCtx(function () {
                          return _cache[1] || (_cache[1] = [_createTextVNode("上一步")]);
                        }),
                        _: 1
                      }, 8, ["icon"]), _createVNode(_component_el_button, {
                        type: "success",
                        onClick: nextStep
                      }, {
                        default: _withCtx(function () {
                          return [_cache[2] || (_cache[2] = _createTextVNode("下一步")), _createVNode(_component_el_icon, null, {
                            default: _withCtx(function () {
                              return [_createVNode(_unref(ArrowRight))];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_divider)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tabs, {
            ref_key: "tabRef",
            ref: tabRef,
            modelValue: tab.active,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return tab.active = $event;
            })
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_tab_pane, {
                style: {
                  "height": "100%"
                },
                label: "选择表",
                name: "table-select"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(TableSelect, {
                    ref_key: "tableSelectRef",
                    ref: tableSelectRef,
                    onSelect: handleTableSelect
                  }, null, 512)];
                }),
                _: 1
              }), _createVNode(_component_el_tab_pane, {
                style: {
                  "height": "100%"
                },
                label: "属性调整",
                name: "table-prop"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(TableProp, {
                    ref_key: "tablePropRef",
                    ref: tablePropRef,
                    "table-name": tab.tableSelect.tableName
                  }, null, 8, ["table-name"])];
                }),
                _: 1
              }), _createVNode(_component_el_tab_pane, {
                label: "代码生成",
                name: "code-gen"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(CodeGenerator, {
                    business: tab.tableProp.business
                  }, null, 8, ["business"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["modelValue"])])])];
        }),
        _: 1
      });
    };
  }
});